module.exports = __webpack_public_path__ + "img/logo.5cf29623.png";